import type { AxiosRequestConfig } from 'axios';
import type { z } from 'zod';
import { http } from './http';
import { toApiError } from './errors';

/**
 * Typed request helpers. Every response is validated at the boundary, so a
 * backend contract change surfaces as one clear error instead of `undefined`
 * crashing deep inside a component (the Flutter app needed `_parsePrice`-style
 * defensive code for exactly this reason).
 */
export async function getParsed<S extends z.ZodType>(
  url: string,
  schema: S,
  config?: AxiosRequestConfig,
): Promise<z.output<S>> {
  try {
    const res = await http.get<unknown>(url, config);
    return schema.parse(res.data);
  } catch (e) {
    throw toApiError(e);
  }
}

export async function send<S extends z.ZodType>(
  method: 'post' | 'put' | 'patch' | 'delete',
  url: string,
  schema: S,
  data?: unknown,
  config?: AxiosRequestConfig,
): Promise<z.output<S>> {
  try {
    const res = await http.request<unknown>({ ...config, method, url, data });
    return schema.parse(res.data);
  } catch (e) {
    throw toApiError(e);
  }
}
